import { render } from "./Solidarity.view.vue?vue&type=template&id=8a2e760e"
import script from "./Solidarity.view.vue?vue&type=script&lang=js"
export * from "./Solidarity.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__